"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getSpinnerServicesTemplate = void 0;
const lit_1 = require("lit");
const lit_html_1 = require("lit-html");
const decorators_js_1 = require("lit/decorators.js");
const typedi_1 = require("typedi");
const control_1 = require("@common/form/control");
const translation_1 = require("@translation/services/translation");
const domain_1 = require("@domain/services/domain");
const user_1 = require("@auth/services/user");
const services_1 = require("@common/services/services");
const loader_1 = require("@common/loader/templates/loader");
const scenario_1 = require("@event/services/scenario");
const type_1 = require("@event/type");
const popup_1 = require("../services/popup");
/**
 * Всплывающее окно дополнительных услуг домена
 */
let SpinnerServicesPopup = class SpinnerServicesPopup extends lit_1.LitElement {
    /**
     * Конструктор
     */
    constructor() {
        super();
        /**
         * Загрузка
         */
        this.loading = true;
        /**
         * Ошибка
         */
        this.error = '';
        /**
         * Процесс
         */
        this.process = false;
        /**
         * Форма режима
         */
        this.modeForm = new control_1.Form({
            mode: new control_1.TextControl('search'),
        });
        /**
         * Форма поиска
         */
        this.searchForm = new control_1.Form({
            query: new control_1.TextControl(''),
        });
        /**
         * Форма услуги
         */
        this.serviceForm = new control_1.Form({
            domain: new control_1.TextControl(''),
        });
        /**
         * Режим
         */
        this.mode = 'search';
        /**
         * Параметры
         */
        this.params = {};
        /**
         * Гость
         */
        this.guest = false;
        /**
         * Тип услуги
         */
        this.type = '';
        /**
         * Домены
         */
        this.domains = [];
        this.userService = typedi_1.Container.get(user_1.UserService);
        this.domainService = typedi_1.Container.get(domain_1.DomainService);
        this.translationService = typedi_1.Container.get(translation_1.TranslationService);
        this.servicesService = typedi_1.Container.get(services_1.ServicesService);
        this.scenarioService = typedi_1.Container.get(scenario_1.ScenarioService);
        this.popupService = typedi_1.Container.get(popup_1.PopupService);
        this.login = this.login.bind(this);
        this.search = this.search.bind(this);
        this.buy = this.buy.bind(this);
    }
    /**
     * Обрабатывает событие инициализации
     */
    connectedCallback() {
        var _a;
        super.connectedCallback();
        (_a = this.modeForm.get('mode')) === null || _a === void 0 ? void 0 : _a.registerOnChange(() => {
            var _a;
            this.mode = (_a = this.modeForm.get('mode')) === null || _a === void 0 ? void 0 : _a.getValue();
        });
        this.init();
    }
    /**
     * Инициализирует состояние
     */
    init() {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            this.loading = true;
            const { type, mode } = this.params;
            this.type = type;
            if (mode) {
                (_a = this.modeForm.get('mode')) === null || _a === void 0 ? void 0 : _a.setValue(mode);
            }
            try {
                const { data: { guest } } = yield this.userService.info();
                this.guest = guest;
                if (!this.guest) {
                    const { data: { items } } = yield this.domainService.getUserDomains();
                    this.domains = items;
                    this.serviceForm.patchValue({ domain: this.domains[0] || '' });
                }
            }
            catch (err) {
                this.error = err.message || 'Something went wrong';
            }
            finally {
                this.loading = false;
            }
        });
    }
    /**
     * Устанавливает корень структуры
     */
    createRenderRoot() {
        return this;
    }
    /**
     * Генерирует представление
     */
    render() {
        const getDescriptionBlock = () => this.type === 'bemail'
            ? (0, lit_html_1.html) `
                <p class="mb-5">${this.translationService.instant('aa_bemailtext1')}</p>
            ` : this.type === 'weebly' ? (0, lit_html_1.html) `
                <p class="mb-5">${this.translationService.instant('aa_weeblytext0')}</p>
            ` : '';
        return (0, lit_html_1.html) `
            <div class="modal fade" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
                <div class="modal-dialog modal-lg modal-dialog-centered modal-fullscreen-sm-down">
                    <div class="modal-content">
                        <div class="modal-header pb-4">
                            <button type="button" class="btn-close" data-bs-dismiss="modal"></button>
                        </div>
                        
                        ${this.loading
            ? (0, lit_html_1.html) `
                            <div class="modal-body pt-0">
                                <div class="mb-5">
                                    ${(0, loader_1.getLoaderTemplate)(true, this.translationService)}
                                </div>
                            </div>     
                        ` : this.error ? (0, lit_html_1.html) `
                            <div class="modal-body pt-0">
                                <div class="mb-5">
                                    ${this.error}
                                </div>
                            </div>  
                        ` : (0, lit_html_1.html) `
                            <div class="modal-body pt-0">
                                <div class="mb-5">
                                    <h2 class="mb-5">${this.translationService.instant('aa_bemailtext0')}</h2>
                                    ${getDescriptionBlock()}
                                    
                                    <art-radio-field
                                        class="d-flex justify-content-around mb-5"
                                        .control="${this.modeForm.get('mode')}"
                                        .values="${{
            search: this.translationService.instant('i_want_to_buy_a_new_domain'),
            choice: this.translationService.instant('i_already_have_domain'),
        }}"
                                    ></art-radio-field>
                                    
                                    ${this.mode === 'search'
            ? (0, lit_html_1.html) `
                                            <div>
                                                <art-text-field class="d-block mb-5" name="domain" .control="${this.searchForm.get('query')}" placeholder="${this.translationService.instant('domain_name')}" @enter="${this.search}"></art-text-field>
                                                <button class="btn btn-primary w-100" @click="${this.search}">${this.translationService.instant('search')}</button>
                                            </div>                                                            
                                        ` : (0, lit_html_1.html) `
                                            <div>
                                                ${this.guest
            ? (0, lit_html_1.html) `
                                                    <p class="mb-5">${this.translationService.instant('please_login_to_proceed')}</p>
                                                    <button class="btn btn-primary w-100" @click="${this.login}">${this.translationService.instant('av_log_in')}</button>
                                                ` : this.domains.length > 0
            ? (0, lit_html_1.html) `
                                                    <art-select-field
                                                        class="d-block mb-5"
                                                        .control="${this.serviceForm.get('domain')}"
                                                        .values="${this.domains.reduce((carry, domain) => {
                carry[domain] = domain;
                return carry;
            }, {})}"
                                                    ></art-select-field>
                                                    <button class="btn btn-primary w-100" @click="${this.buy}" ?disabled="${this.process}">${this.translationService.instant('buy')}</button>
                                                    ` : (0, lit_html_1.html) `
                                                    <p>${this.translationService.instant('you_dont_have_any_domains')}</p>
                                                    `}
                                            </div>
                                        `}
                                </div>
                            </div>
                        `}
                    </div>
                </div>
            </div>
        `;
    }
    /**
     * Обрабатывает авторизацию пользователя
     */
    login() {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.popupService.open('login', {});
            this.scenarioService.createScenario([type_1.EventType.USER_AUTHENTICATED, type_1.EventType.MODAL_CLOSED], scenario_1.SCENARIO_TRIGGER_TYPE.ALL, [type_1.EventType.MODAL_CLOSED], () => {
                this.popupService.open('spinner-services', Object.assign(Object.assign({}, this.params), { mode: this.mode }));
            });
        });
    }
    /**
     * Обрабатывает действие поиска нового домена
     */
    search() {
        const { query } = this.searchForm.getValue();
        if (!query) {
            return;
        }
        window.location.href = `/search?query=${query}`;
    }
    /**
     * Обрабатывает действие покупки услуги
     */
    buy() {
        return __awaiter(this, void 0, void 0, function* () {
            this.process = true;
            const { domain } = this.serviceForm.getValue();
            let redirect = '';
            try {
                if (this.type === 'weebly') {
                    const { rate, period } = this.params;
                    const { data: { redirect: redirectResponse } } = yield this.servicesService.registerWeebly(domain, rate, period);
                    redirect = redirectResponse;
                }
                if (this.type === 'bemail') {
                    const { count, period } = this.params;
                    const { data: { redirect: redirectResponse } } = yield this.servicesService.registerBusinessEmail(domain, count, period);
                    redirect = redirectResponse;
                }
                window.location.href = redirect;
            }
            catch (err) {
            }
            finally {
                this.process = false;
            }
        });
    }
};
__decorate([
    (0, decorators_js_1.state)(),
    __metadata("design:type", Boolean)
], SpinnerServicesPopup.prototype, "loading", void 0);
__decorate([
    (0, decorators_js_1.state)(),
    __metadata("design:type", String)
], SpinnerServicesPopup.prototype, "error", void 0);
__decorate([
    (0, decorators_js_1.state)(),
    __metadata("design:type", Boolean)
], SpinnerServicesPopup.prototype, "process", void 0);
__decorate([
    (0, decorators_js_1.state)(),
    __metadata("design:type", String)
], SpinnerServicesPopup.prototype, "mode", void 0);
__decorate([
    (0, decorators_js_1.property)(),
    __metadata("design:type", Object)
], SpinnerServicesPopup.prototype, "params", void 0);
SpinnerServicesPopup = __decorate([
    (0, decorators_js_1.customElement)('art-spinner-services-popup'),
    __metadata("design:paramtypes", [])
], SpinnerServicesPopup);
/**
 * Возвращает шаблон дополнительных услуг домена
 */
function getSpinnerServicesTemplate(params) {
    return (0, lit_html_1.html) `<art-spinner-services-popup .params="${params}"></art-spinner-services-popup>`;
}
exports.getSpinnerServicesTemplate = getSpinnerServicesTemplate;
window.PopupController.registerTemplate('spinner-services', getSpinnerServicesTemplate);
